module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "banner"
  }, [_c('div', {
    class: ['banner-cover', _vm.type]
  }, [(_vm.type === 'video') ? _c('video', {
    staticClass: "banner-player",
    attrs: {
      "loop": "",
      "autoplay": "",
      "muted": ""
    },
    domProps: {
      "muted": true
    }
  }, [_c('source', {
    attrs: {
      "src": _vm.url,
      "type": "video/mp4"
    }
  })]) : _c('img', {
    staticClass: "banner-player",
    attrs: {
      "src": _vm.url,
      "alt": ""
    }
  })]), _vm._v(" "), _vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4907f5de"}!./~/vue-loader/lib/selector.js?type=template&index=0!./pc/yiqijian-video/components/Banner/index.vue
// module id = 111
// module chunks = 3 4